/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.846.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationContextClassLoader } from './ApplicationContextClassLoader';
import {
    ApplicationContextClassLoaderFromJSON,
    ApplicationContextClassLoaderFromJSONTyped,
    ApplicationContextClassLoaderToJSON,
} from './ApplicationContextClassLoader';
import type { Environment } from './Environment';
import {
    EnvironmentFromJSON,
    EnvironmentFromJSONTyped,
    EnvironmentToJSON,
} from './Environment';

/**
 * 
 * @export
 * @interface ApplicationContext
 */
export interface ApplicationContext {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    applicationName?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationContext
     */
    startupDate?: number;
    /**
     * 
     * @type {object}
     * @memberof ApplicationContext
     */
    autowireCapableBeanFactory?: object;
    /**
     * 
     * @type {ApplicationContext}
     * @memberof ApplicationContext
     */
    parent?: ApplicationContext;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    id?: string;
    /**
     * 
     * @type {Environment}
     * @memberof ApplicationContext
     */
    environment?: Environment;
    /**
     * 
     * @type {number}
     * @memberof ApplicationContext
     */
    beanDefinitionCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationContext
     */
    beanDefinitionNames?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof ApplicationContext
     */
    parentBeanFactory?: object;
    /**
     * 
     * @type {ApplicationContextClassLoader}
     * @memberof ApplicationContext
     */
    classLoader?: ApplicationContextClassLoader;
}

/**
 * Check if a given object implements the ApplicationContext interface.
 */
export function instanceOfApplicationContext(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationContextFromJSON(json: any): ApplicationContext {
    return ApplicationContextFromJSONTyped(json, false);
}

export function ApplicationContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'applicationName': !exists(json, 'applicationName') ? undefined : json['applicationName'],
        'startupDate': !exists(json, 'startupDate') ? undefined : json['startupDate'],
        'autowireCapableBeanFactory': !exists(json, 'autowireCapableBeanFactory') ? undefined : json['autowireCapableBeanFactory'],
        'parent': !exists(json, 'parent') ? undefined : ApplicationContextFromJSON(json['parent']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'environment': !exists(json, 'environment') ? undefined : EnvironmentFromJSON(json['environment']),
        'beanDefinitionCount': !exists(json, 'beanDefinitionCount') ? undefined : json['beanDefinitionCount'],
        'beanDefinitionNames': !exists(json, 'beanDefinitionNames') ? undefined : json['beanDefinitionNames'],
        'parentBeanFactory': !exists(json, 'parentBeanFactory') ? undefined : json['parentBeanFactory'],
        'classLoader': !exists(json, 'classLoader') ? undefined : ApplicationContextClassLoaderFromJSON(json['classLoader']),
    };
}

export function ApplicationContextToJSON(value?: ApplicationContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'applicationName': value.applicationName,
        'startupDate': value.startupDate,
        'autowireCapableBeanFactory': value.autowireCapableBeanFactory,
        'parent': ApplicationContextToJSON(value.parent),
        'id': value.id,
        'environment': EnvironmentToJSON(value.environment),
        'beanDefinitionCount': value.beanDefinitionCount,
        'beanDefinitionNames': value.beanDefinitionNames,
        'parentBeanFactory': value.parentBeanFactory,
        'classLoader': ApplicationContextClassLoaderToJSON(value.classLoader),
    };
}

